import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="w-full bg-white shadow px-6 py-4 flex items-center justify-between">
      <div className="text-xl font-semibold">
        
      </div>

      <ul className="flex items-center space-x-6">
        <li className="cursor-pointer hover:text-black-600 transition">
          <Link to="/agents">Agents</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
